import { ActionReducer, INIT } from '@ngrx/store';

import { AppState } from '../app/app.state';
import { HomeState } from '../home/home.state';
import { RootState } from '../root-state.model';
import { RootStoreActions } from '../root-store.actions';

export function changeAssetFactory() {
  return (reducer: ActionReducer<RootState>): ActionReducer<RootState> => {
    return (state, action) => {
      if (action?.type === RootStoreActions.ChangeAsset.type) {
        return reducer(
          {
            app: {
              ...state.app,
              initialized: false,
            } as AppState,
            home: {
              productUpdates: state.home.productUpdates,
            } as HomeState,
            userProfile: state.userProfile,
            menu: state.menu,
          } as any,
          { type: INIT }
        );
      }

      return reducer(state, action);
    };
  };
}
